import refiner from "refiner-js";

import { refiner as refinerApi } from "apis-v2/callables";
import getLogger, { LogGroup } from "js/core/logger";

const logger = getLogger(LogGroup.ANALYTICS);

// Initialize Refiner
export function initRefiner() {
    if (!window.refinerProjectId || window.refinerInitialized) {
        return;
    }

    refiner("setProject", window.refinerProjectId);
    window.refinerInitialized = true;
}

//Identify user in Refiner
export async function identifyRefiner(user, userIdentity) {
    if (!window.refinerInitialized) return;

    // Fetch Refiner signature from backend (for identity verification)
    let refinerSignature = null;
    try {
        const refinerSignatureResponse = await refinerApi.getRefinerSignature();
        refinerSignature = refinerSignatureResponse?.signature;
    } catch (err) {
        // Identity verification may not be enabled, continue without signature
        logger.info("Refiner signature not available, continuing without identity verification", { error: err.message });
    }

    const identifyPayload = {
        id: user.uid,
        ...userIdentity,
    };

    refiner("identifyUser", identifyPayload, {
        signature: refinerSignature
    });
}

// Track an event in Refiner
export function trackRefiner(eventId, eventProperty, user) {
    if (!user || !user.uid || !window.refinerInitialized) return;
    refiner("trackEvent", eventId, eventProperty || {});
}
